module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/img_lp-data__box-img01-16cc9a35e03a1b2fe21f6c0148769f41.png";